import { render, staticRenderFns } from "./priceSettingList.vue?vue&type=template&id=0ce0a007&"
import script from "./priceSettingList.vue?vue&type=script&lang=js&"
export * from "./priceSettingList.vue?vue&type=script&lang=js&"
import style0 from "./priceSettingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports